import { ArtistVerified } from "@enums/artistVerified";
import blueVerified from "@images/shared/verified-blue-icon.svg";
import redVerified from "@images/shared/verified-red-icon.svg";

export const getVerifiedIcon = (
  verified: ArtistVerified.BlueVerified | ArtistVerified.RedVerified
) => (verified === ArtistVerified.BlueVerified ? blueVerified : redVerified);

export const ArtistVerifiedMap = {
  [ArtistVerified.BlueVerified]: "Blue Verified",
  [ArtistVerified.RedVerified]: "Red Verified",
  [ArtistVerified.NotVerified]: "Not Verified",
};
